import { Theme } from '@afterpaytouch/core'
import { BASE_PATH } from '../../env'
import { IllustrationColors, IllustrationConfig, IllustrationName, ILLUSTRATIONS } from './types'

const ILLUSTRATION_PATH = [BASE_PATH, 'images', 'illustrations'].join('/')

export const THEME_COLOR_MAP: Record<Theme, IllustrationColors> = {
  [Theme.AP]: 'mint',
  [Theme.Pegasus]: 'green',
  [Theme.Cash]: 'green',
  [Theme.Kelpie]: 'mint',
  [Theme.KelpieMint]: 'mint',
} as const

export const ILLUSTRATION_CONFIG: Record<IllustrationName, IllustrationConfig> = {
  [ILLUSTRATIONS.EyeRecognition]: {
    variants: {
      green: {
        light: [ILLUSTRATION_PATH, 'eye-recognition-green-light.svg'].join('/'),
        dark: [ILLUSTRATION_PATH, 'eye-recognition-green-dark.svg'].join('/'),
      },
      mint: {
        light: [ILLUSTRATION_PATH, 'eye-recognition-mint-light.svg'].join('/'),
        dark: [ILLUSTRATION_PATH, 'eye-recognition-mint-dark.svg'].join('/'),
      },
    },
    aspectRatio: 2.09243,
  },
  [ILLUSTRATIONS.CoffeeSpill]: {
    variants: {
      green: {
        light: [ILLUSTRATION_PATH, 'coffee-spill-green--light.svg'].join('/'),
        dark: [ILLUSTRATION_PATH, 'coffee-spill-green--dark.svg'].join('/'),
      },
      mint: {
        light: [ILLUSTRATION_PATH, 'coffee-spill-mint--light.svg'].join('/'),
        dark: [ILLUSTRATION_PATH, 'coffee-spill-mint--dark.svg'].join('/'),
      },
    },
    aspectRatio: 1.312,
  },
  [ILLUSTRATIONS.ConeDog]: {
    variants: {
      green: {
        light: [ILLUSTRATION_PATH, 'cone-dog-green--light.svg'].join('/'),
        dark: [ILLUSTRATION_PATH, 'cone-dog-green--dark.svg'].join('/'),
      },
      mint: {
        light: [ILLUSTRATION_PATH, 'cone-dog-mint--light.svg'].join('/'),
        dark: [ILLUSTRATION_PATH, 'cone-dog-mint--dark.svg'].join('/'),
      },
    },
    aspectRatio: 1.312,
  },
}
